import React, { useCallback } from 'react';
import SideModalWrapper from '@components/wrapper/SideModalWrapper';
import NavList from './NavList';
import { LAYOUT_TYPE } from '@typings/setting/layoutType';
import styled from 'styled-components';

const SideWrapper = styled.div`
  min-height: 100%;
  background: var(--menuBackgroundColor);
  color: var(--menuTextColor);
  font-family: var(--menuFontFamily);
`;

type SideMenuPanelProps = {
  show: boolean;
  onClose: () => void;
  header?: React.ReactNode;
  footer?: React.ReactNode;
};

function SideMenuPanel({ show, onClose, header, footer }: SideMenuPanelProps) {
  const handleNavClickCapture = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    const target = e.target as HTMLElement;
    const anchor = target.closest('a');
    if (anchor) {
      // NavLink 클릭 시 사이드 메뉴 닫기 (폴더 토글은 div로 되어 있어 영향 없음)
      onClose();
    }
  }, [onClose]);

  return (
    <SideModalWrapper show={show} outsideClick={onClose}>
      <SideWrapper>
        {header}
        <div onClickCapture={handleNavClickCapture}>
          <NavList forceLayoutType={LAYOUT_TYPE.LEFT} />
        </div>
        {footer}
      </SideWrapper>
    </SideModalWrapper>
  );
}

export default React.memo(SideMenuPanel);
